const getFinanceRowTime = (row) => {
  const value = row?.date
    || row?.transactionDate
    || row?.createdAt
    || row?.raw?.date
    || row?.raw?.transactionDate
    || row?.raw?.createdAt
    || row?.raw?.allocatedAt
    || 0;
  const time = new Date(value).getTime();
  return Number.isFinite(time) ? time : 0;
};

const documentLabel = (row) => String(
  row?.documentLabel
  || row?.description
  || row?.documentNo
  || row?.sourceId
  || row?.raw?.documentLabel
  || ''
);

const compareFinanceRowsAscending = (a, b) => {
  const dateDiff = getFinanceRowTime(a) - getFinanceRowTime(b);
  if (dateDiff !== 0) return dateDiff;
  return documentLabel(a).localeCompare(documentLabel(b));
};

const compareFinanceRowsDescending = (a, b) => {
  const dateDiff = getFinanceRowTime(b) - getFinanceRowTime(a);
  if (dateDiff !== 0) return dateDiff;
  return documentLabel(b).localeCompare(documentLabel(a));
};

const sortFinanceRowsAscending = (rows = []) => (
  [...(Array.isArray(rows) ? rows : [])].sort(compareFinanceRowsAscending)
);

const sortFinanceRowsDescending = (rows = []) => (
  [...(Array.isArray(rows) ? rows : [])].sort(compareFinanceRowsDescending)
);

const withChronologicalRunningBalance = (rows = [], direction = 'desc') => {
  let runningBalance = 0;
  const chronological = sortFinanceRowsAscending(rows).map((row) => {
    runningBalance += Number(row.convertedAmount || 0);
    return {
      ...row,
      runningBalance
    };
  });

  return direction === 'asc' ? chronological : chronological.reverse();
};

const withRunningBalanceNewestFirst = (rows = []) => withChronologicalRunningBalance(rows, 'desc');

const withChronologicalStatementBalance = (rows = [], direction = 'desc', openingBalance = 0) => {
  let runningBalance = Number(openingBalance || 0);
  const chronological = sortFinanceRowsAscending(rows).map((row) => {
    runningBalance += Number(row.debit || 0) - Number(row.credit || 0);
    return {
      ...row,
      runningBalance
    };
  });

  return direction === 'asc' ? chronological : chronological.reverse();
};

const presentRowsBySortDirection = (chronologicalRows = [], direction = 'desc') => (
  direction === 'asc'
    ? [...(Array.isArray(chronologicalRows) ? chronologicalRows : [])]
    : [...(Array.isArray(chronologicalRows) ? chronologicalRows : [])].reverse()
);

export {
  getFinanceRowTime,
  compareFinanceRowsAscending,
  compareFinanceRowsDescending,
  sortFinanceRowsAscending,
  sortFinanceRowsDescending,
  withChronologicalRunningBalance,
  withChronologicalStatementBalance,
  withRunningBalanceNewestFirst,
  presentRowsBySortDirection
};
